import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "all",
  color: [],
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    toggleColor: (state, action) => {
      let isExist = state.color.includes(action.payload);
      if (!isExist) {
        state.color.push(action.payload);
      } else {
        let filterOut = state.color.filter((c) => c !== action.payload) || [];
        state.color = filterOut;
      }

      state.searchTerm = action.payload;
    },
  },
});

export const filterReducer = filterSlice.reducer;
export const { setStatus, toggleColor } = filterSlice.actions;
